import { Component, OnInit, OnChanges, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ContentShowerService } from './content-shower.service';
import { SvgIconComponent } from '../icons/svg-icon.component';

@Component({
    selector: 'ep-content-shower',
    templateUrl: './content-shower.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent]
})

export class ContentShowerComponent {

    @Input() linkText: string;
    @Input() contentType: string;
    @Input() content: string;

    constructor(private contentShowerService: ContentShowerService) { }
    
    showContent() {
        this.contentShowerService.showContent(this.content, this.contentType);
    }
}
